import App from './components/App';
import { AppContainer } from 'react-hot-loader';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';

import CmicCtxt from './context/CmicContext';
import ActionCtxt from './context/ActionContext';
import { CURRENT_OFFICE_THEME, THEME_ID } from './shared/styles';
import './styles/officeThemes.scss';
/* global document, Office, module, require */

initializeIcons();

let isOfficeInitialized = false;
const title = 'CMiC for Outlook';

let currentOfficeTheme = CURRENT_OFFICE_THEME;

const getThemeClass = (themeId) => {
	switch (themeId) {
		case THEME_ID.BLACK:
			return 'office-theme-black';
		case THEME_ID.DARK_GREY:
			return 'office-theme-dark-grey';
		case THEME_ID.COLORFUL:
			return 'office-theme-colorful';
		case THEME_ID.WHITE:
		default:
			return 'office-theme-white';
	}
};

const render = (Component, currentTheme) => {
	const container = document.getElementById('container');
	// Remove any previous theme class
	container.classList.remove(
		'office-theme-white',
		'office-theme-black',
		'office-theme-dark-grey',
		'office-theme-colorful'
	);
	// Add the current theme class
	container.classList.add(getThemeClass(currentTheme.themeId));

	ReactDOM.render(
		<CmicCtxt currentTheme={currentTheme}>
			<ActionCtxt>
				<HashRouter>
					<AppContainer>
						<Component
							title={title}
							isOfficeInitialized={isOfficeInitialized}
							currentOfficeTheme={currentTheme}
						/>
					</AppContainer>
				</HashRouter>
			</ActionCtxt>
		</CmicCtxt>,
		container,
	);
};

/* Render application after Office initializes */
Office.onReady(() => {
	isOfficeInitialized = true;

	const themeForOutlook = Office.context.officeTheme;

	currentOfficeTheme = {
		bodyBackgroundColor: themeForOutlook?.bodyBackgroundColor,
		bodyForegroundColor: themeForOutlook?.bodyForegroundColor,
		controlBackgroundColor: themeForOutlook?.controlBackgroundColor,
		controlForegroundColor: themeForOutlook?.controlForegroundColor,
		themeId: themeForOutlook?.themeId,
	};

	if (themeForOutlook === undefined) {
		currentOfficeTheme = CURRENT_OFFICE_THEME;
	} else {
		if (themeForOutlook?.themeId) {
			currentOfficeTheme = currentOfficeTheme;
		} else {
			if (themeForOutlook?.bodyBackgroundColor === '#212121') {
				currentOfficeTheme = { ...currentOfficeTheme, themeId: THEME_ID.BLACK };
			} else {
				currentOfficeTheme = { ...currentOfficeTheme, themeId: THEME_ID.WHITE };
			}
		}
	}

	render(App, currentOfficeTheme);
});

/* Initial render showing a progress bar */
render(App, currentOfficeTheme);

if (module.hot) {
	module.hot.accept('./components/App', () => {
		const NextApp = require('./components/App').default;
		render(NextApp, currentOfficeTheme);
	});
}
